<template>
  <div class="content-box">

    <div v-if="loadingStatus.full" class="full-loading">
      <HconLoading v-model="loadingStatus.full" />
    </div>

    <HconMyPageUsrInfo @data-loaded="setUserCommInfo" />

    <div class="sub-wrapper">
      <HconMyPageSideMenu />

      <div class="sub-contents">

        <!-- H캐시 충전 안내 s -->
        <div class="border-title title">
          <p class="title">H캐시 충전<span class="desc">H캐시 충전하면 상품 구매 시 더욱 편리하게 이용하실 수 있습니다.</span></p>
        </div>
        <!-- H캐시 충전 안내 e -->

        <!-- 현재 보유한 H캐시 s -->
        <div class="box-gray rounded12 flex jc-c">
          <img src="@/assets/images/pc/sub-hcon/img-hmoney.png" width="60" height="60" alt="">
          <p class="ml8">
            현재 보유한 H캐시 <span class="text-green fs30 font-bold ml13">{{ HconCommonUtils.format.expComma(commonInfo?.userHcashDto?.availableHcash)}}</span> 원
          </p>
        </div>
        <!-- 현재 보유한 H캐시 e -->
        
        <!-- 충전금액 및 충전수단 s -->
        <div class="mt28">
          <table class="tbl-type tbl-type-row">
            <caption></caption>
            <colgroup>
              <col style="width:9%" />
              <col style="width:auto" />
            </colgroup>
            <tbody>
              <tr>
                <th class="center">충전금액</th>
                <td class="left">
                  <div class="flex">
                    <div class="flex gap8">
                      <button type="button" v-for="(charge, index) in chargeAmounts" :key="index" class="btn md" :class="chargeActiveIndex === index ? 'btn-outline-green active' : 'btn-outline'" @click="handleChargeBtnClick(index, charge.value)">{{ charge.amount }}</button>
                    </div>
                    <div class="left-auto">
                      <div class="form-box">
                        <div class="form-group row wd280">
                          <HconInput @blur="setChargeAmt" type="text" v-model="inputChrgAmt" label="직접입력" labelClass="mn-wd67" inputClass="md" placeholder="" @iput-delete="onInputTextReset" />
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th class="center">충전수단</th>
                <td class="left">
                    <div class="flex gap8">
                      <button type="button" v-for="(payMethod, index) in payMethods" :key="index" class="btn md" :class="[payMethod.customClass, payMethodActiveIndex === index ? 'btn-outline-green active' : 'btn-outline-gray']" @click="payMethodActiveIndex = index; dropDownCardCd = ''">{{ payMethod.name }}</button>
                    </div>
                    <div v-if="payMethodActiveIndex === 0" class="mt10 flex gap8">
                      <HconComPCDropDown type="dropdownBox" v-model="dropDownCardCd" defaultLabel="카드선택" selectBoxTitleClass="wd200 md" :dropdownOptions="cardList" />
                      <HconComPCDropDown type="dropdownBox" v-model="dropDownCardOption" defaultLabel="일시불" selectBoxTitleClass="wd150 md" :dropdownOptions="cardOptionList" :disabled="dropDownCardOptionTF" />
                    </div>
                  <ul class="dot-list mt20">
                    <li>신용카드는 {{chargeCondition.t1ElctcPossMinAmt.toLocaleString()}}원 이상부터 충전 가능합니다.</li>
                    <li>신용카드로 300,000원 이상 충전하는 경우 전자금융거래 기본법에 의하여 신용카드용 공인인증서가 필요합니다.</li>
                    <li>신용카드 부정사용을 방지하기 위해 보유카드에 따라 '인터넷 안전 결제(ISP)' 혹은 '안심클릭' 결제를 의무적으로 사용해야 합니다.</li>
                    <li>결제 가능 카드 : 현대 / 국민 / 신한 / 비씨 / 삼성 / 롯데 / 우리 / 카카오뱅크 / KDB산업 / 제주 등</li>
                    <li>이용 한도 : 월 한도액 100만원 (카드사별 상이할 수 있습니다.)</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="box-gray inset40 mt40">
          <h4 class="title">H캐시 충전 안내</h4>
          <ul class="dot-list mt24">
            <li>H캐시 충전 후 현금처럼 사용 가능하며, 신용카드 또는 계좌이체와 복합결제가 가능합니다.</li>
            <li>H캐시 충전 후 사용 이력이 존재하지 않는 경우, 결제 후 7일 이내에 <span class="text-green">'마이 Hcon > H캐시 관리'</span>에서 충전취소 가능합니다.</li>
            <li>H캐시 환불 신청 시 신청 금액의 5%가 환불 수수료로 공제됩니다.</li>
            <li>H캐시 충전 시 회원별 1회 최대 {{chargeCondition.t1ElctcPossMaxAmt.toLocaleString()}}원까지 가능하며, 충전 포인트 보유 한도는 {{chargeCondition.rttnPossMaxAmt.toLocaleString()}}원입니다.</li>
            <li>H캐시 유효기간은 충전 일로부터 {{ chargeCondition.vlidTermYcnt.toLocaleString()}}년입니다.</li>
          </ul>
        </div>
        <!-- 충전금액 및 충전수단 e -->

        <!-- 약관동의 s -->
        <div class="border-top-black mt28">
          <HconCheckBox @change="chkAgreeCheckedChanged" :checked="chkAgreeChecked == 'Y' ? true : false" v-model="chkAgree" type="default" label="충전 할 H캐시 금액을 최종 확인하였으며, H캐시 구매에 동의하십니까?" name="allCheckBtn" customClass="mt28" labelClass="font-bold fs18 gap5" :showTextBefore="true" text="[필수]" textClass="text-red ml8" :hide-label="false">
            <span class="text-gray02 fs16 font-normal ml3">(전자상거래법 제8조 2항)</span>
          </HconCheckBox>
        </div>
        <!-- 약관동의 e -->

        <!-- 버튼 s -->
        <div class="button-box col2 mt40">
          <button type="button" @click="undoChargeHcash" class="btn btn-outline lg">취소</button>
          <!-- <button type="button" @click="doChargeHcash" class="btn lg">충전하기(임시)</button> -->
          <button type="button" @click="doChargeHcashNew" class="btn lg">충전하기</button>
        </div>
        <!-- 버튼 e -->
      </div>
    </div> 
      
  </div>

  <!-- 이니시스 PG -->
  <PaymentForInicis ref="inicisRef" :inicis-request="inicisRequest" />

</template>
<script lang="ts" setup>
import HconInput from '@/components/com/HconComPCInputField.vue'
import HconCheckBox from '@/components/com/HconComPCCheckbox.vue'
import HconMyPageSideMenu from '@/components/corner/pc/HconCornerMypageSideMenuPC.vue';
import HconMyPageUsrInfo from '@/components/corner/pc/HconCornerUserInfoPC.vue';
import HconComPCDropDown from '~/components/com/HconComPCDropDown.vue';
import { usePopup } from '@/composables/hconUsePopup'
import { useRoute } from 'vue-router';
import { HconCommonUtils } from '@/utils/hcon-common-utils'
import { MEMBER_CODE, ORDER_CODE, COMMON_CODE } from '~/constants/hconMessageConstants';
import type {UserCommonInfoDto } from '~/types/mypage/backend-dto-types';
import type { RefSymbol } from '@vue/reactivity';

const fetchBuilder        = useHconFetchBuilder();
const { showAlert, showConfirm } = usePopup()
// lnb
const route = useRoute()
const { refreshCnt, commonInfo } = useHeader();
const chkAgreeChecked = ref("N")
const chkAgree = ref("")
const dropDownCardCd = ref("")
const dropDownCardOption = ref("")
const dropDownCardOptionTF = ref(true)

const chkAgreeCheckedChanged = (isChecked : boolean) => { chkAgreeChecked.value= isChecked ? 'Y' :'N' }
// 현재 사용자 공통 정보 가져오기;
const setUserCommInfo = (data : UserCommonInfoDto) => {
  commonInfo.value = data
}
// 충전금액
interface PriceItem {
  amount: string
  value: number
}

const chargeAmounts: PriceItem[] = [
  { amount: '+1만원', value: 10000},
  { amount: '+5만원', value: 50000},
  { amount: '+10만원', value: 100000},
  { amount: '+50만원', value: 500000},
  { amount: '+200만원', value: 2000000},
]

const chargeActiveIndex = ref<number | null>(null);
const inputChrgAmt = ref<string>('100,000원')
const currentAmount = ref<number>(100000)

const handleChargeBtnClick = (index: number, value: number): void => {
  chargeActiveIndex.value = index

  currentAmount.value += value

  if(currentAmount.value > chargeCondition.value.t1ElctcPossMaxAmt) {
    currentAmount.value = chargeCondition.value.t1ElctcPossMaxAmt
  }

  inputChrgAmt.value = HconCommonUtils.format.addWon(currentAmount.value)
}

// 직접입력 초기화
const onInputTextReset = () => {
  chargeActiveIndex.value = null
  currentAmount.value = 0
  inputChrgAmt.value = ''
}

const setChargeAmt = (inputV :string) => {
  currentAmount.value = Number(inputChrgAmt.value.split('원')[0].replace(/[^0-9]/g,''))

  if(currentAmount.value > chargeCondition.value.t1ElctcPossMaxAmt) {
    currentAmount.value = chargeCondition.value.t1ElctcPossMaxAmt
  }

  inputChrgAmt.value = HconCommonUtils.format.addWon(currentAmount.value)
}
// 충전수단
interface MethodItem {
  name: string,
  customClass: string
}

const payMethods: MethodItem[] = [
  { name: '신용카드', customClass: 'credit-card' },
  { name: '계좌이체', customClass: 'account-transfer' }
]

const cardList            = reactive<any[]>([])
const cardOptionList = reactive<any[]>([])
const payMethodActiveIndex = ref<number | null>(null)

  // // H캐시 관리
  // ALT_HCON_9051: 'H캐시 충전이 취소되었습니다.',
  // ALT_HCON_9112: 'H캐시 충전이 완료되었습니다.',
  // ALT_HCON_9113: 'H캐시 환불 신청이 완료되었습니다.',
const doChargeHcash = async () => {

  if(currentAmount.value < 1000) {
    showAlert({
      title: '충전 가능 금액 안내',
      message: HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9048),
      confirmText: '확인'
    })
    return false;
  }
  
  if(chkAgreeChecked.value == 'N'){
    showAlert({
      title: '구매 동의',
      message: HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9049),
      confirmText: '확인'
    })
    return false;
  }

  fetchBuilder.post<AjaxResult<any>>('/api/v1/mypage/hcash/charge/' + currentAmount.value)
  .query()
  .build().execute()
  .then(async (result) => {
        if(result.resultCode == '200') {
          showAlert({
            title: 'H캐시 충전 완료',
            message: HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9112),
            confirmText: '확인'
          })

          useRouter().push({path:"/pc/mypage/hcash/charge/complete/", query : {trdNo : result.data}});
        } else if (result.resultCode == '29178'){
          showAlert({
            title: 'H캐시 충전 오류',
            message: result.resultMessage,
            confirmText: '확인'
          })
        } 
    })
}








// ######################################################################################

import PaymentForInicis from "@/components/com/ComPCInicisForm.vue";
import HconLoading from '@/components/com/HconComPCLoading.vue'; // loading
import type { CodeDto, CommFileDto } from '~/types/common/backend-dto-types';

import { ref, nextTick, onMounted, onUnmounted } from 'vue';
import type { InicisRequest } from "~/types/payment/backend-dto-types";

// 로딩바 타입 정의
export interface Loadingstatus {
  full: boolean
}


interface chargeCond {
  t1ElctcPossMinAmt : number
  t1ElctcPossMaxAmt : number
  rttnPossMaxAmt : number
  vlidTermYcnt : number
  rmnPntAmt : number
}

const chargeCondition = ref<chargeCond>({
  t1ElctcPossMinAmt : 0,
  t1ElctcPossMaxAmt : 0,
  rttnPossMaxAmt : 0,
  vlidTermYcnt : 0,
  rmnPntAmt : 0
});

// // loading-state라는 키값으로 전역 상태 생성(기본값 false)
const loadingStatus = useState<Loadingstatus>('loading-status', () => ({
  full: false //전역 레이아웃 로딩
}))

const getChargeCondition = async () => {
  fetchBuilder.get<any>('/api/v1/mypage/hcash/charge-condition')
      .query({userKey : useHconAuthInfo().getIfPossible()?.userContext.userKey})
      .build().execute()
      .then(async (result) => {
              if(result) chargeCondition.value = result.data

              refreshCnt();
          });
}

const inicisRef = ref<typeof PaymentForInicis>()
const inicisRequest = ref<InicisRequest>()

// 컴포넌트 리스너
onMounted (() => {
  fetchBuilder.get<AjaxResult<{hc_incs_crdc_cd : CodeDto[] }>>('/api/v1/common/codes/hc_incs_crdc_cd')
  .build()
  .execute()
  .then((result) => {

    const cardDataList = result.data.hc_incs_crdc_cd.map( item => {
      return {
        key   : item.commDtlCd,
        value : item.commDtlCdNm,
      }
    });

    cardList.splice(0,cardList.length, ...cardDataList);
    cardList.sort((a,b) => a.key - b.key)
    cardOptionList.push({
        key   : '',
        value : '일시불',
      })
  });

  getChargeCondition();
  // close
  const observer = new MutationObserver((mutations) => {
    for(const mutation of mutations) {
      if(mutation.type === 'childList') {
        mutation.removedNodes.forEach((node) => {
          if(node instanceof HTMLElement) {
            if(node.id.toLowerCase().includes('inicis') || node.id.toLowerCase().includes('standard')) {
              loadingStatus.value.full = false
            }
          }
        })
      }
    }
  })
  
  observer.observe(document.body, { childList: true, subtree: true })

 onUnmounted (() => {
    observer.disconnect()
  })
})

const doChargeHcashNew = async () => {

  if(payMethodActiveIndex.value === null) {
    showAlert({
      title: '충전 수단 선택',
      message: HconCommonUtils.format.message(ORDER_CODE.ALT_HCON_9205, '충전'),
      confirmText: '확인'
    })
    return
  }

  if(payMethodActiveIndex.value === 0 && dropDownCardCd.value == '') {
    showAlert({
      title: '충전 카드 선택',
      message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001, '충전하실 카드를', '선택'),
      confirmText: '확인'
    })
    return
  }

  if(currentAmount.value < chargeCondition.value.t1ElctcPossMinAmt) {
    showAlert({
      title: '충전 가능 금액 안내',
      message: HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9048),
      confirmText: '확인'
    })
    return
  }
  
  if(currentAmount.value + chargeCondition.value.rmnPntAmt > chargeCondition.value.rttnPossMaxAmt) {
    showAlert({
      title: '충전 가능 한도 초과 안내',
      message: HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9178, chargeCondition.value.rttnPossMaxAmt.toLocaleString()+"원"),
      confirmText: '확인'
    })
    return
  }
  
  
  if(chkAgreeChecked.value == 'N'){
    showAlert({
      title: '구매 동의',
      message: HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9049),
      confirmText: '확인'
    })
    return
  }

  // 이니시스 요청파라미터 세팅
  setInicisParameter()

  await nextTick()

  if(inicisRef.value) {
    loadingStatus.value.full = true
    inicisRef.value.request()
  } else {
    showAlert({
      title: '알림',
      message: HconCommonUtils.format.message(ORDER_CODE.ALT_HCON_9204),
      confirmText: '확인'
    })
  }
}

// 이니시스 요청파라미터 세팅
const setInicisParameter = () => {
  inicisRequest.value = {
      hcPymtUsgTyp: "CHARGE"                /* HCON 결제용도타입 CHARGE, ORDER */
    , ordGdsSmryNm: "H캐시 충전"             /* 주문상품요약명 */
    , hcPymtMnsCd: payMethodActiveIndex.value === 0 ? "1001" : "1002" /* HCON 결제수단코드 */ // 신용카드? 계좌이체
    , inicisPrice: currentAmount.value      /* 이니시스결제금액 */
    , crdCd: dropDownCardCd.value                             /* 카드코드 */
    , instMcnt: 0                           /* 할부개월수 */
    , merchantData: {
        rfrNo: ''                 /* 참조번호(주문번호 or 포인트적립승인번호) */
      , paymentDetailList: [
          { hcPymtMnsCd: payMethodActiveIndex.value === 0 ? "1001" : "1002", pymtAmt: currentAmount.value }
      ]
    }
  }
}

// ######################################################################################



const undoChargeHcash = async () => {
  // ALT_HCON_9050: 'H캐시 충전취소를 하시겠습니까?',
  const result = await showConfirm({
    title: 'H캐시 충전 취소 확인',
    message: HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9050),
    confirmText: '확인',
    cancelText: '취소'
  })

  if(result) {
    showAlert({
      title: 'H캐시 충전 취소 안내',
      message: HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9051),
      confirmText: '확인'
    })
    useRouter().back();
  }
}

</script>
<style lang="scss" scoped>
@use "@/assets/scss/pc/order-hcon.scss" as *;
@use "@/assets/scss/pc/mypage-hcon.scss" as *;

</style>